import type { Locale } from "@kavval/lingui-config/locales";

type FormatNumber = (params: { number: number; locale: Locale }) => string;
export const formatNumber: FormatNumber = ({ number, locale }) =>
  new Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
  }).format(number);
